// components/Layout/Layout.jsx
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import TopNav from './TopNav';
import './Layout.css';

export default function LayoutWrapper({ children, hideSidebar = false }) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div
      className={`app-shell ${collapsed ? 'is-collapsed' : ''} ${hideSidebar ? 'no-sidebar' : ''}`}
      data-collapsed={collapsed ? 'true' : 'false'}
    >
      {!hideSidebar && (
        <aside className={`app-sidebar ${collapsed ? 'collapsed' : ''}`}>
          <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(v => !v)} />
        </aside>
      )}

      <div className={`app-main ${collapsed ? 'sidebar-collapsed' : ''} ${hideSidebar ? 'no-sidebar' : ''}`}>
        {hideSidebar && <TopNav />}
        <main className="layout-main">{children}</main>
      </div>
    </div>
  );
}
